export const Noise = () => {
  return <div aria-hidden="true" className="noise-layer" data-testid="noise-overlay" />;
};

export default Noise;
